package meineglasfaser.api

import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format
import kotlinx.datetime.format.DateTimeComponents
import kotlinx.datetime.format.char
import kotlinx.datetime.offsetAt
import kotlin.time.Instant

fun Instant.formatted(): String {
    val format = DateTimeComponents.Format {
        day()
        char('.')
        monthNumber()
        char('.')
        year()
        char(' ')
        hour()
        char(':')
        minute()
        char(':')
        second()
    }
    val offset = TimeZone.currentSystemDefault().offsetAt(this)
    return this.format(format, offset)
}

fun LocalDate.formatted(): String {
    return this.toString() // TODO
}
